var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      { staticClass: "l-modal-mask", on: { click: _vm.closeOnBackdrop } },
      [
        _c("div", { staticClass: "l-modal-wrapper" }, [
          _c("div", { class: _vm.containerClass }, [
            _c(
              "div",
              { class: _vm.header },
              [
                _vm._t("header", [
                  _vm._v("\n            default header\n          ")
                ]),
                _vm._v(" "),
                _vm._t("close", [
                  _c(
                    "span",
                    {
                      staticClass: "l-modal-close",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.$emit("close")
                        }
                      }
                    },
                    [
                      _c("button", { staticClass: "btn btn-close" }, [
                        _c("span", { staticClass: "mod-icon-close" })
                      ])
                    ]
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: [_vm.body] },
              [
                _vm._t("body", [
                  _vm._v("\n            default body\n          ")
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.footer },
              [
                _vm._t("footer", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary pull-right ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: {
                            click: function($event) {
                              _vm.$emit("ok")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Save\n                  "
                          ),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ])
              ],
              2
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-701ac82d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-701ac82d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = null
// module chunks = 